module.exports = __webpack_public_path__ + "img/carpeta.c40b0283.svg";